import { Box, Typography } from '@mui/material';
import { Button } from '@mui/material';

export default function NoRecordMessage({ showAllStrategies }) {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box display="block" sx={{ p: 35 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '10vh',
            fontSize: '100px',
            color: (theme) => theme.fuel6Tokens.JddcColorIconSecondary
          }}
        >
          <fuel-icon name="arrow_back" />
        </Box>
        <div
          style={{
            textAlign: 'center'
          }}
        >
          <Typography variant="labelLarge" fontWeight="bold">
            Use left side filters to search for Strategies
          </Typography>
          <br />
          <Typography variant="labelLarge">
            Click the button below to see all strategies
          </Typography>
          <br />
          <Button
            style={{ marginCenter: 'auto' }}
            variant="secondary"
            onClick={showAllStrategies}
          >
            Show All Strategies
          </Button>
        </div>
      </Box>
    </Box>
  );
}
